import React, {useState} from 'react';
import Page from './page';
import {FormControl} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import {navigateNext, setParticipants} from '../../action/actions';
import {publicBuildUrl} from '../../config/config';

const NumberOfMembers = () => {
    const [participants, _setParticipants] = useState(0);
    const {app: {room: {ageGroup}}} = useSelector((state) => state);
    const dispatch = useDispatch();

    const handleNumberOfMembers = () => {
        dispatch(setParticipants(participants));
        dispatch(navigateNext());
    };

    return (
        <Page title={'Number of members'}>
            <div className={'bodyContainer'}>
                <div className={'bodyContainerColumn'}>
                    <div
                      style={{
                         ...styles.button,
                         width: '100%',
                         backgroundImage: `url('${publicBuildUrl}buttons/ButtonAgeGroup${ageGroup}OnRollOver.png')`,
                         backgroundSize: '100%',
                     }}>
                        <div style={styles.buttonText}>{ageGroup === 1 ? '10 - 13 jaar' : 'Vanaf 13 jaar' }</div>
                    </div>
                </div>
                <div className={'bodyContainerColumn'}
                     style={styles.button}>
                    <div style={styles.labelContainer}>
                        <img src={`${publicBuildUrl}icons/IconParticipants.png`} style={{width: '70px'}} alt={'# verwachte deelnemers'}/>
                        <div style={styles.labelText}># verwachte deelnemers</div>
                    </div>
                    <div>
                        <FormControl
                            style={styles.input}
                            placeholder='20'
                            aria-label='Deelnemers'
                            aria-describedby='Deelnemers'
                            value={participants}
                            onChange={(e) => _setParticipants(Number(e.target.value))}
                        />
                    </div>
                    <div style={styles.buttonConfirmContainer} onClick={() => handleNumberOfMembers()}>
                        <div style={styles.buttonConfirmText}>
                            <img src={`${publicBuildUrl}icons/IconForward.png`} style={{width: '95%'}} alt={'volgende'}/>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
}

const styles = {
    button: {
        cursor: 'pointer',
        aspectRatio: '702/291',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
    },
    buttonText: {
        color: '#ffffff',
        fontSize: '23px',
        fontWeight: 500,
        marginLeft: '25%'
    },
    labelContainer: {
        backgroundColor: '#003d4c',
        display: 'flex',
        width: '548px',
        height: '124px',
        borderBottomLeftRadius: 8,
        borderTopLeftRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    labelText: {
        color: '#ffffff',
        fontFamily: 'Ubuntu',
        fontSize: '20px',
        fontWeight: 500,
        marginLeft: '20px',
        outline: 'none',
    },
    input: {
        borderWidth: 0,
        color: '#E42460',
        height: '124px',
        width: '70px',
        fontFamily: 'Ubuntu',
        fontSize: '20px',
        textAlign: 'center',
    },
    buttonConfirmContainer: {
        backgroundColor: '#003d4c',
        display: 'flex',
        width: '75px',
        height: '124px',
        borderBottomRightRadius: 8,
        borderTopRightRadius: 8,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonConfirmText: {
        color: '#ffffff',
        cursor: 'pointer',
        fontFamily: 'Ubuntu',
        fontSize: '25px',
        fontWeight: 500,
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '5px',
    },
}

export default NumberOfMembers;
